import axios from "axios";
import { API_PLANOS } from "../consts/api";
import { orderBy, snakeCase, uniqBy } from "lodash";

function filter(dataPlans, city, gener) {
  let plans = dataPlans.filter(plan => {
    const { cidade, local } = plan;

    return snakeCase(city) === snakeCase(cidade) && snakeCase(gener) === snakeCase(local);
  });

  let infra = uniqBy(plans, "infraestrutura");

  infra = infra.map(plan => {
    return plan.infraestrutura;
  });

  return infra.map(infNm => {
    plans = orderBy(plans, "velocidade");

    let filtredPlans = plans.filter(p => {
      if (p.infraestrutura === infNm) {
        return p;
      }
    });

    return {
      infraestrutura: infNm,
      plans: filtredPlans
    };
  });
}

export default async function(cidade, genero) {
  try {
    const resp = await axios.post(API_PLANOS);

    let items = resp.data;

    return filter(items, cidade, genero);
  } catch (e) {
    throw e;
  }
}
